export default __webpack_public_path__ + "static/media/chuttersnap-8nMjIn195p0-unsplash.017a17cb.jpg";